import { render, staticRenderFns } from "./DowntimeCommentCreateBox.vue?vue&type=template&id=3c0f1b44&scoped=true&"
import script from "./DowntimeCommentCreateBox.vue?vue&type=script&lang=js&"
export * from "./DowntimeCommentCreateBox.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeCommentCreateBox.vue?vue&type=style&index=0&id=3c0f1b44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f1b44",
  null
  
)

export default component.exports